import { FunctionalComponent, h } from '@stencil/core';
import { getClassListString } from '../component-utils/stencilUtils';

interface AafpDateLinkProps {
  date: string;
  description?: string;
  link: HTMLElement;
  [key: string]: any;
}

export const AafpDateLink: FunctionalComponent<AafpDateLinkProps> = ({ date, description, link }) => (
  <div
    class={getClassListString({
      'adl-date-link--has-date': !!date,
      'adl-date-link': true,
    })}
  >
    <div class="adl-date-link__header">
      {date && <div class="adl-body adl-date-link__date">{date}</div>}
      <div class="adl-date-link__aafp-link" ref={(el) => el && el.append(link)}></div>
    </div>
    {description && <div class="adl-body adl-date-link__description">{description}</div>}
  </div>
);
